/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {createEmployeeRole} from '../api'

export const useMutationCreateEmployeeRole = createReactQueryMutationHook('createEmployeeRole', createEmployeeRole)
